import FooterApp from './FooterApp'

export default FooterApp
// eslint-disable-next-line import/export
export * from './FooterApp'
